import React from 'react';

const AuthContext = React.createContext(undefined);

export default AuthContext;
